import "./RestaurantBar.css";

export default function RestaurantBar({
  restaurants = [],
  activeRestaurant = 0,
  onRestaurantChange,
  getRestaurantKey,
  getRestaurantLabel,
  getRestaurantStatus,
  actions,
  children,
  className = "",
}) {
  const actionContent = actions ?? children;

  return (
    <header className={`restaurant-bar ${className}`.trim()}>
      <div className="restaurant-bar__tabs">
        {restaurants.map((restaurant, index) => {
          const status = getRestaurantStatus?.(restaurant, index) || {};
          const key =
            getRestaurantKey?.(restaurant, index) ??
            restaurant?._id ??
            restaurant?.id ??
            index;
          const label =
            getRestaurantLabel?.(restaurant, index) ??
            restaurant?.store?.businessName ??
            restaurant?.businessName ??
            restaurant?.name ??
            "Restaurant";
          const count = Number(status.count || 0);

          return (
            <button
              key={key}
              className={`restaurant-bar__tab ${
                status.hasGrayMiss ? "gray-miss" : ""
              } ${status.hasYellowMiss ? "yellow-miss" : ""} ${
                activeRestaurant === index ? "active" : ""
              }`.trim()}
              onClick={() => onRestaurantChange?.(index, restaurant)}
              type="button"
            >
              {label}
              {count > 0 && (
                <span className="restaurant-bar__count" title={status.countTitle || "pending"}>
                  {" "}
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {actionContent}
    </header>
  );
}
